/**
 * Compute global round labels for matches using BFS distance from Final.
 * Shared between TournamentBracket, SchedulePanel, TimetablePage, and pdfExport.
 */

const DEPTH_CODES = ["F", "SF", "QF", "R8", "R16", "R32", "R64", "R128", "R256"];

export function computeGlobalLabelOverrides(matches) {
  if (!matches || matches.length === 0) return {};

  const feeders = {};
  for (const m of matches) {
    if (m.next_match_id) {
      if (!feeders[m.next_match_id]) feeders[m.next_match_id] = [];
      feeders[m.next_match_id].push(m.match_id);
    }
  }

  let finals = matches.filter(m => !m.next_match_id && m.round === "F");
  if (finals.length === 0) finals = matches.filter(m => !m.next_match_id);

  const depth = {};
  const queue = [];
  for (const f of finals) { depth[f.match_id] = 0; queue.push({ id: f.match_id, d: 0 }); }
  while (queue.length > 0) {
    const { id, d } = queue.shift();
    for (const fid of (feeders[id] || [])) {
      if (depth[fid] === undefined) {
        depth[fid] = d + 1;
        queue.push({ id: fid, d: d + 1 });
      }
    }
  }

  const labelOverrides = {};
  for (const m of matches) {
    const d = depth[m.match_id];
    if (d !== undefined) {
      const code = DEPTH_CODES[d] || `R${Math.pow(2, d)}`;
      if (code === "F") labelOverrides[m.match_id] = "F";
      else if (code === "SF") labelOverrides[m.match_id] = `SF${(m.position_in_round ?? 0) + 1}`;
      else if (code === "QF") labelOverrides[m.match_id] = `QF${(m.position_in_round ?? 0) + 1}`;
      else labelOverrides[m.match_id] = `${code}-${(m.position_in_round ?? 0) + 1}`;
    }
  }
  return labelOverrides;
}
